import { useState } from "react";
import CDPViewer from "./CDPViewer";
import { apiConfig } from "../config/api.config"; // ajusta si tu ruta es distinta

const getTokenLoose = () => {
  try {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("access_token") ||
      ""
    );
  } catch {
    return "";
  }
};

export default function EnviarCDP({
  onClose,
  onSubmit,
  userRole,
  solicitud,
  cdpFormulario,

  // ✅ NUEVOS (para solicitante)
  contratoFirmado,
  contractId,
}) {
  const [archivoNecesidad, setArchivoNecesidad] = useState(null);
  const [archivoBancop, setArchivoBancop] = useState(null);

  const [estadoCdp, setEstadoCdp] = useState("");
  const [archivoCdpRespuesta, setArchivoCdpRespuesta] = useState(null);
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [loading, setLoading] = useState(false);

  const [fechaDocumento, setFechaDocumento] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");

  const isPresupuestoView = userRole === "presupuesto" && !!solicitud;
  const isPresupuestoResponse =
    isPresupuestoView &&
    (solicitud?.status === "pending" || solicitud?.status === "pendiente");

  const safeResponseAttachments = Array.isArray(solicitud?.response_attachments)
    ? solicitud.response_attachments
    : [];

  const enviarCdpABackend = async ({ resolvedContractId, necesidadFile, bancopFile }) => {
    const token = getTokenLoose();

    const url = apiConfig.getUrl("/api/presupuesto/requests/index.php"); // o tu endpoint real

    const payload = {
      contract_id: resolvedContractId,
      request_type: "CDP",
      attachments: { necesidad: null, bancop: null }, // si lo manejas como URLs, aquí no aplica file directo
      sent_by: "front",
      status: "pendiente",
      sent_at: new Date().toISOString(),
    };

    // Si tu backend espera JSON (como tu tabla attachments LONGTEXT), debes subir archivos primero y guardar URLs.
    // Por ahora respetamos onSubmit (recomendado) para tu flujo actual.
    console.log("DEBUG enviarCdpABackend url:", url, payload);

    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });

    const raw = await resp.text().catch(() => "");
    if (!resp.ok) throw new Error(raw || `Error HTTP ${resp.status}`);

    try {
      return raw ? JSON.parse(raw) : { ok: true };
    } catch {
      return { ok: true, raw };
    }
  };

  const handleEnviar = async () => {
    setLoading(true);

    try {
      // =========================
      // PRESUPUESTO RESPONDIENDO
      // =========================
      if (isPresupuestoResponse) {
        if (!estadoCdp) {
          alert("Debe seleccionar el estado del CDP");
          return;
        }

        if (estadoCdp === "aprobado") {
          if (!fechaDocumento) return alert("Debe seleccionar la fecha del CDP");
          if (!numeroDocumento.trim()) return alert("Debe ingresar el número del CDP");
        }

        if (estadoCdp === "negado" && !motivoRechazo.trim()) {
          alert("Debe ingresar el motivo del rechazo");
          return;
        }

        const payload = {
          requestId: solicitud.id,
          approved: estadoCdp === "aprobado",
          responseAttachments: archivoCdpRespuesta ? [archivoCdpRespuesta] : [],
          notes: motivoRechazo || "",
          fecha_documento: estadoCdp === "aprobado" ? fechaDocumento : null,
          numero_documento: estadoCdp === "aprobado" ? numeroDocumento.trim() : null,
        };

        if (typeof onSubmit === "function") {
          await onSubmit(payload);
        }

        alert("Proceso realizado correctamente.");
        onClose?.();
        return;
      }

      // =========================
      // SOLICITANTE ENVIANDO
      // =========================
      if (!archivoNecesidad || !archivoBancop) {
        alert("Debe adjuntar la necesidad y el Bancop antes de enviar.");
        return;
      }

      const resolvedContractId =
        contractId ||
        contratoFirmado?.id ||
        solicitud?.contract_id ||
        solicitud?.contractId ||
        null;

      if (!resolvedContractId) {
        alert("No se pudo detectar el contract_id para enviar a Presupuesto.");
        return;
      }

      const payload = {
        type: "CDP",
        attachments: {
          necesidad: archivoNecesidad,
          bancop: archivoBancop,
        },
        contract_id: resolvedContractId,
      };

      if (typeof onSubmit === "function") {
        await onSubmit(payload);
      } else {
        await enviarCdpABackend({
          resolvedContractId,
          necesidadFile: archivoNecesidad,
          bancopFile: archivoBancop,
        });
      }

      alert("Proceso realizado correctamente.");
      onClose?.();
    } catch (error) {
      console.error("Error:", error);
      alert("Error al procesar: " + (error?.message || "Error desconocido"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
      <div style={{ background: "#fff", padding: "2rem", borderRadius: 10, width: 520, maxHeight: "80vh", overflowY: "auto" }}>
        <h3>{isPresupuestoView ? "Solicitud CDP - Detalles" : "Enviar CDP"}</h3>

        {!isPresupuestoView && (
          <>
            <div style={{ marginBottom: "1rem" }}>
              <label><strong>Cargar necesidad *</strong></label><br />
              <input type="file" accept=".pdf,.doc,.docx" onChange={(e) => setArchivoNecesidad(e.target.files?.[0] || null)} />
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <label><strong>Cargar Bancop *</strong></label><br />
              <input type="file" accept=".pdf,.doc,.docx" onChange={(e) => setArchivoBancop(e.target.files?.[0] || null)} />
            </div>
          </>
        )}

        {isPresupuestoView && (
          <div style={{ marginBottom: "1rem" }}>
            <CDPViewer solicitud={solicitud} cdpFormulario={cdpFormulario} responseAttachments={safeResponseAttachments} />
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button onClick={onClose} disabled={loading}>Cancelar</button>
          <button onClick={handleEnviar} disabled={loading}>{loading ? "Enviando..." : "Enviar"}</button>
        </div>
      </div>
    </div>
  );
}
